import Logger from './logger';

export function isBrowserSupported () {
    if(navigator.userAgent.match(/msie\s[5-9]/i) !== null) {
        Logger.info('IE < 10 not supported');
        // IE 5-9 not supported
        return false;
    }

    // Browser supported
    return true;
}

export function getiOSVersion() {
    // There is some iOS in Windows Phone...
    // https://msdn.microsoft.com/en-us/library/hh869301(v=vs.85).aspx
    if(window.MSStream === undefined) {
        const match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        if (match !== undefined && match !== null) {
            const version = [
                parseInt(match[1], 10),
                parseInt(match[2], 10)
                // parseInt(match[3] || 0, 10)
            ];
            return parseFloat(version.join('.'));
        }
    }
    return null;
}

// Source:
// https://bitsrc.io/tomlandau/simple-js/global/is-mobile/code
export const isMobile = {
    getUserAgent: () => {
        return navigator.userAgent;
    },
    android: function() {
        return /Android/i.test(isMobile.getUserAgent()) && !isMobile.windows();
    },
    blackBerry: function() {
        return /BlackBerry|BB10|PlayBook/i.test(isMobile.getUserAgent());
    },
    iPhone: function() {
        return /iPhone/i.test(isMobile.getUserAgent()) && !isMobile.iPad() && !isMobile.windows();
    },
    iPod: function() {
        return /iPod/i.test(isMobile.getUserAgent());
    },
    iPad: function() {
        return /iPad/i.test(isMobile.getUserAgent());
    },
    iOS: function() {
        return (isMobile.iPad() || isMobile.iPod() || isMobile.iPhone());
    },
    opera: function() {
        return /Opera Mini/i.test(isMobile.getUserAgent());
    },
    windows: function() {
        return /Windows Phone|IEMobile|WPDesktop/i.test(isMobile.getUserAgent());
    },
    kindleFire: function() {
        return /Kindle Fire|Silk|KFAPWA|KFSOWI|KFJWA|KFJWI|KFAPWI|KFAPWI|KFOT|KFTT|KFTHWI|KFTHWA|KFASWI|KFTBWI|KFMEWI|KFFOWI|KFSAWA|KFSAWI|KFARWI/i.test(isMobile.getUserAgent());
    },
    any: function() {
        return (isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.opera() || isMobile.windows());
    }
};
